<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.57 10.927L18.886 6.89C19.153 6.566 18.922 6.077 18.501 6.077H7.191V5H5V19H7.191V15.776H18.501C18.922 15.776 19.153 15.287 18.886 14.963L15.57 10.927Z"/>
</svg>
